import { type Message, api } from '@here/api'

// TODO move this somewhere better
export type DisplayMessage = Omit<Message, 'last_seen'> &
	Partial<
		Awaited<ReturnType<typeof getChannelHistory>> extends (infer R)[] | undefined
			? R
			: never
	>

/**
 * Deletes a setup by its ID.
 * @param {string} id - The ID of the setup to delete.
 * @returns {Object|null} The deleted setup data, or null if deletion fails.
 */
export const getChannelHistory = async (id?: string, focusMessageId?: string) => {
	if (focusMessageId) {
		return
	}
	if (!id) {
		return
	}

	const { data, error } = await api()
		.from('message')
		.select(`
      *,
      profile (
        username,
        last_seen (updated_at)
      ),
      profile_private (
        role
      ),
			message_reaction (
				emoji,
				created_by,
				message_id
    )
    `)
		.eq('channel_id', id)
		.limit(60)
		.order('created_at', { ascending: false })

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	return data.reverse() || []
}
